<script setup lang="ts">
const el = ref()
const v = useElementVisibility(el)
</script>

<template>
  <div ref="el" relative h-690px w-full lg:h-496px>
    <svg
      :class="v && 'animated-fade-in-right'"
      absolute animated lt-lg="bottom-0"
      class="right-[clamp(-10000px,calc((100vw-1920px)/1.8+0px),0px)] z-1"
      sm="right-[clamp(-10000px,calc((100vw-1920px)/2.4+0px),0px)] z-1"
      lg="right-[clamp(-10000px,calc((100vw-1920px)/2+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="1131" height="496" viewBox="0 0 1131 496" fill="none"
    >
      <path d="M1131 496H0L342.5 0H1131V496Z" fill="#CE0000" />
    </svg>

    <div absolute inset-0 container row items-center>
      <!-- <VoteLivePhone class="!absolute" left-10px /> -->
      <img
        :class="v && 'animated-fade-in-left'" src="/images/group-1000002742-prod.webp" w-353px animated lt-lg="mb-200px" sm="ml-12" lg="ml-0"
      >

      <div lt-lg="absolute bottom-40px right-15px" z-2 ml-4 lg:ml-12>
        <p class="text-35px font-bold lh-100% lg:text-80px" :class="v && 'animated-fade-in-right'" animated animated-delay-400>
          START VOTING
        </p>
        <p :class="v && 'animated-fade-in-right'" mt-20px text-24px font-bold animated animated-delay-500 lg:text-53px>
          STEP 2
        </p>
        <p :class="v && 'animated-fade-in-right'" fond-bold text-15px animated animated-delay-600 lg:text-24px>
          With ROMA in hand, you’re all set to vote.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
